import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  connect() {
    this.sortable = Sortable.create(this.element, {
      handle: ".bi-grip-vertical",
      animation: 150,
      onEnd: () => this.submitOrder()
    })
  }

  disconnect() {
    this.sortable?.destroy()
  }

  submitOrder() {
    const ids = [...this.element.querySelectorAll("[data-id]")]
        .map(el => el.dataset.id)

    const form = this.createForm(ids)
    document.body.appendChild(form)
    form.requestSubmit()
    form.remove()
  }

  createForm(ids) {
    const form = document.createElement("form")
    form.method = "POST"
    form.action = "/account/vehicle_bays/reorder"

    // Rails CSRF
    const token = document.querySelector('meta[name="csrf-token"]').content

    form.innerHTML = `
      <input type="hidden" name="authenticity_token" value="${token}">
      ${ids.map(id => `<input type="hidden" name="ids[]" value="${id}">`).join("")}
    `

    return form
  }
}